import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { IS_INGAME } from "@/components/cef/cefShared";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import RouteWipe from "@/components/RouteWipe";
import BannedGate from "@/components/BannedGate";
import CookieConsent from "@/components/CookieConsent";
import ConsentGate from "@/components/ConsentGate";
import AuthCallback from "@/components/AuthCallback";
import HomePage from "@/pages/HomePage";
import RoadmapPage from "@/pages/RoadmapPage";
import AssetPacksPage from "@/pages/AssetPacksPage";
import ServicesPage from "@/pages/ServicesPage";
import JoinSalesPage from "@/pages/JoinSalesPage";
import JobsPage from "@/pages/JobsPage";
import DirectoryPage from "@/pages/DirectoryPage";
import ModHubPage from "@/pages/ModHubPage";
import WorkshopPage from "@/pages/WorkshopPage";
import ServersHubPage from "@/pages/ServersHubPage";
import ServerGuidePage from "@/pages/ServerGuidePage";
import BridgeGuidePage from "@/pages/BridgeGuidePage";
import WikiPage from "@/pages/WikiPage";
import ContractSignPage from "@/pages/ContractSignPage";
import EngineLandingPage from "@/pages/EngineLandingPage";
import PortfolioPage from "@/pages/PortfolioPage";
import CareersPage from "@/pages/CareersPage";
import NewsPage from "@/pages/NewsPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import AuthPage from "@/pages/AuthPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPage from "@/pages/AdminPage";
import ProfilePage from "@/pages/ProfilePage";
import DevHubPage from "@/pages/DevHubPage";
import SupportPage from "@/pages/SupportPage";
import BannedPage from "@/pages/BannedPage";
import TeamPage from "@/pages/TeamPage";
import FounderStoryPage from "@/pages/FounderStoryPage";
import PressKitPage from "@/pages/PressKitPage";
import CreatorKeysPage from "@/pages/CreatorKeysPage";
import TestingPage from "@/pages/TestingPage";
import TesterPortalPage from "@/pages/TesterPortalPage";
import NewsroomPage from "@/pages/NewsroomPage";
import ModdersPage from "@/pages/ModdersPage";
import SalesPage from "@/pages/SalesPage";
import PortalPage from "@/pages/PortalPage";
import GalleryPage from "@/pages/GalleryPage";
import MarketplacePage from "@/pages/MarketplacePage";
import CommandPage from "@/pages/CommandPage";
import PaymentSuccessPage, { PaymentCancelPage } from "@/pages/PaymentPages";
import UnsubscribePage from "@/pages/UnsubscribePage";
import DealRoomPage from "@/pages/DealRoomPage";
import JoinCreatorsPage from "@/pages/JoinCreatorsPage";
import NdisJoinPage from "@/pages/NdisJoinPage";
import NdisPortalPage from "@/pages/NdisPortalPage";
import NdisGate from "@/components/NdisGate";
import AccessibilityDrawer from "@/components/AccessibilityDrawer";
import VoiceControl from "@/components/VoiceControl";
import CreatorPage from "@/pages/CreatorPage";
import CefLoadingPage from "@/pages/CefLoadingPage";
import PhoneCefPage from "@/pages/PhoneCefPage";
import CadCefPage from "@/pages/CadCefPage";
import CourtCefPage from "@/pages/CourtCefPage";
import MenuCefPage from "@/pages/MenuCefPage";
import AdminCefPage from "@/pages/AdminCefPage";
import CreatorCefPage from "@/pages/CreatorCefPage";
import CasinoCefPage from "@/pages/CasinoCefPage";
import RouletteTablePage from "@/pages/RouletteTablePage";
import SlotsCefPage from "@/pages/SlotsCefPage";
import GrowCefPage from "@/pages/GrowCefPage";
import CookCefPage from "@/pages/CookCefPage";
import DealCefPage from "@/pages/DealCefPage";
import CryptoCefPage from "@/pages/CryptoCefPage";
import ForensicsCefPage from "@/pages/ForensicsCefPage";
import TriageCefPage from "@/pages/TriageCefPage";
import TalkCefPage from "@/pages/TalkCefPage";
import StopCefPage from "@/pages/StopCefPage";
import StocksCefPage from "@/pages/StocksCefPage";
import TravelCefPage from "@/pages/TravelCefPage";
import JoinCefPage from "@/pages/JoinCefPage";
import RadioCefPage from "@/pages/RadioCefPage";
import CommunityProfilePage from "@/pages/CommunityProfilePage";
import RobCefPage from "@/pages/RobCefPage";
import EftposCefPage from "@/pages/EftposCefPage";
import RollCefPage from "@/pages/RollCefPage";
import StoneCefPage from "@/pages/StoneCefPage";
import LabCefPage from "@/pages/LabCefPage";
import HeistCefPage from "@/pages/HeistCefPage";
import RealtyCefPage from "@/pages/RealtyCefPage";
import PoliticsCefPage from "@/pages/PoliticsCefPage";
import CitizenHubPage from "@/pages/CitizenHubPage";
import CaseFilesPage from "@/pages/CaseFilesPage";
import MuseumPage from "@/pages/MuseumPage";
import CourtRecordsPage from "@/pages/CourtRecordsPage";
import BackdropPage from "@/pages/BackdropPage";
import SteamDonePage from "@/pages/SteamDonePage";
import AppealPage from "@/pages/AppealPage";
import OwnerDeckPage from "@/pages/OwnerDeckPage";
import ProspectChat from "@/components/sales/ProspectChat";
import ScrollToTop from "@/components/ScrollToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import MobileActionBar from "@/components/MobileActionBar";
import { CurrencyProvider } from "@/lib/currency";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — must run before normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/new-citizen" element={<RoadmapPage />} />
          <Route path="/new-citizen/hub" element={<CitizenHubPage />} />
          <Route path="/new-citizen/case-files" element={<CaseFilesPage />} />
          <Route path="/new-citizen/museum" element={<MuseumPage />} />
          <Route path="/new-citizen/court-records" element={<CourtRecordsPage />} />
          <Route path="/new-citizen/backdrop" element={<BackdropPage />} />
          <Route path="/asset-packs" element={<AssetPacksPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/join-sales" element={<JoinSalesPage />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/modhub" element={<ModHubPage />} />
          <Route path="/sdk" element={<Navigate to="/modhub" replace />} />
          <Route path="/new-citizen/workshop" element={<WorkshopPage />} />
          <Route path="/new-citizen/servers" element={<ServersHubPage />} />
          <Route path="/new-citizen/server-guide" element={<ServerGuidePage />} />
          <Route path="/new-citizen/bridge-guide" element={<BridgeGuidePage />} />
          <Route path="/new-citizen/wiki" element={<WikiPage />} />
          <Route path="/sign/:token" element={<ContractSignPage />} />
          <Route path="/unreal-engine-development" element={<EngineLandingPage engineKey="ue5" />} />
          <Route path="/arma-reforger-development" element={<EngineLandingPage engineKey="arma" />} />
          <Route path="/fivem-development" element={<EngineLandingPage engineKey="fivem" />} />
          <Route path="/gta-v-development" element={<Navigate to="/fivem-development" replace />} />
          <Route path="/minecraft-development" element={<EngineLandingPage engineKey="minecraft" />} />
          <Route path="/unity-development" element={<EngineLandingPage engineKey="unity" />} />
          <Route path="/custom-game-modding" element={<EngineLandingPage engineKey="custom" />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/eula" element={<LegalPage variant="eula" />} />
          <Route path="/nda" element={<LegalPage variant="nda" />} />
          <Route path="/privacy" element={<LegalPage variant="privacy" />} />
          <Route path="/refunds" element={<LegalPage variant="refunds" />} />
          <Route path="/creator-terms" element={<LegalPage variant="creator" />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/appeal" element={<AppealPage />} />
          <Route path="/auth/steam/done" element={<SteamDonePage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/deal/:token" element={<DealRoomPage />} />
          <Route path="/join-creators" element={<JoinCreatorsPage />} />
          <Route path="/join-creators-ndis" element={<NdisGate><NdisJoinPage /></NdisGate>} />
          <Route path="/ndis-portal" element={<NdisGate><NdisPortalPage /></NdisGate>} />
          <Route path="/marketplace-terms" element={<NdisGate><LegalPage variant="marketplace" /></NdisGate>} />
          <Route path="/creators" element={<CreatorPage />} />
          <Route path="/login" element={<Navigate to="/auth" replace />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/dev-hub" element={<DevHubPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/community" element={<CommunityProfilePage />} />
          <Route path="/community/:userId" element={<CommunityProfilePage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/story" element={<FounderStoryPage />} />
          <Route path="/presskit" element={<PressKitPage />} />
          <Route path="/creator-keys" element={<CreatorKeysPage />} />
          <Route path="/testing" element={<TestingPage />} />
          <Route path="/testing/portal" element={<TesterPortalPage />} />
          <Route path="/newsroom" element={<NewsroomPage />} />
          <Route path="/newsroom/:slug" element={<NewsroomPage />} />
          <Route path="/modders" element={<ModdersPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/command" element={<CommandPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/banned" element={<BannedPage />} />
          <Route path="/cef/loading/:serverId" element={<CefLoadingPage />} />
          <Route path="/cef/phone/:serverId" element={<PhoneCefPage />} />
          <Route path="/cef/radio/:serverId" element={<RadioCefPage />} />
          <Route path="/cef/rob/:serverId" element={<RobCefPage />} />
          <Route path="/cef/eftpos/:serverId" element={<EftposCefPage />} />
          <Route path="/cef/roll/:serverId" element={<RollCefPage />} />
          <Route path="/cef/stone/:serverId" element={<StoneCefPage />} />
          <Route path="/cef/lab/:serverId" element={<LabCefPage />} />
          <Route path="/cef/cad/:serverId" element={<CadCefPage />} />
          <Route path="/cef/court/:serverId" element={<CourtCefPage />} />
          <Route path="/cef/menu" element={<MenuCefPage />} />
          <Route path="/cef/admin/:serverId" element={<AdminCefPage />} />
          <Route path="/cef/creator/:serverId" element={<CreatorCefPage />} />
          <Route path="/cef/casino/:serverId" element={<CasinoCefPage />} />
          <Route path="/cef/roulette/:serverId" element={<RouletteTablePage />} />
          <Route path="/cef/slots/:serverId" element={<SlotsCefPage />} />
          <Route path="/cef/grow/:serverId" element={<GrowCefPage />} />
          <Route path="/cef/cook/:serverId" element={<CookCefPage />} />
          <Route path="/cef/deal/:serverId" element={<DealCefPage />} />
          <Route path="/cef/crypto/:serverId" element={<CryptoCefPage />} />
          <Route path="/cef/join/:serverId" element={<JoinCefPage />} />
          <Route path="/cef/heist/:serverId" element={<HeistCefPage />} />
          <Route path="/cef/realty/:serverId" element={<RealtyCefPage />} />
          <Route path="/cef/politics/:serverId" element={<PoliticsCefPage />} />
          <Route path="/cef/forensics/:serverId" element={<ForensicsCefPage />} />
          <Route path="/cef/triage/:serverId" element={<TriageCefPage />} />
          <Route path="/cef/talk/:serverId/:ref" element={<TalkCefPage />} />
          <Route path="/cef/stop/:serverId/:stopId" element={<StopCefPage />} />
          <Route path="/cef/stocks/:serverId" element={<StocksCefPage />} />
          <Route path="/cef/travel/:serverId" element={<TravelCefPage />} />
          <Route path="/admin/hub" element={<OwnerDeckPage />} />
    </Routes>
  );
}

function GlobalOverlays() {
  const location = useLocation();
  if (location.pathname.startsWith("/cef/")) return null; // borderless in-game surfaces stay clean
  return (<><MobileActionBar /><AccessibilityDrawer /><VoiceControl /><ProspectChat /></>);
}

/* In-game safety net: if a player somehow lands on a WEBSITE page inside the UE5
   overlay (owner deck link, steam sign-in, external URL), they are never trapped —
   this bar always offers a one-click way back to the in-game server browser. */
function InGameWebBar() {
  const location = useLocation();
  if (!IS_INGAME || location.pathname.startsWith("/cef/")) return null;
  return (
    <div data-testid="ingame-web-bar" className="fixed bottom-0 inset-x-0 z-[999] bg-nc-orange text-black flex items-center justify-center gap-4 px-4 py-2.5 flex-wrap">
      <p className="font-mono text-[9px] uppercase tracking-[0.25em] font-bold">You're viewing the web hub inside the game</p>
      <a data-testid="ingame-back-menu" href="/cef/menu?resume=browser" className="font-mono text-[9px] uppercase tracking-[0.2em] font-bold border border-black/40 px-3 py-1.5 hover:bg-black/10 transition-colors">‹ Back to server browser</a>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <CurrencyProvider>
      <BrowserRouter>
        <BannedGate>
        <SmoothScroll>
          <RouteWipe />
          <ScrollToTop />
          <AnalyticsTracker />
          <AppRouter />
          <GlobalOverlays />
          <InGameWebBar />
          <CookieConsent />
          <ConsentGate />
        </SmoothScroll>
        </BannedGate>
      </BrowserRouter>
      </CurrencyProvider>
      </HelmetProvider>
      <Toaster theme="dark" position="bottom-right" gap={8}
        toastOptions={{ classNames: { toast: "nc-toast", title: "nc-toast-title", description: "nc-toast-desc", icon: "nc-toast-icon", closeButton: "nc-toast-close" } }} />
    </div>
  );
}

export default App;
